import { render, staticRenderFns } from "./NetPremiumProperty.vue?vue&type=template&id=c8f88c24&scoped=true&"
import script from "./NetPremiumProperty.vue?vue&type=script&lang=js&"
export * from "./NetPremiumProperty.vue?vue&type=script&lang=js&"
import style0 from "./NetPremiumProperty.vue?vue&type=style&index=0&id=c8f88c24&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c8f88c24",
  null
  
)

export default component.exports